export default "__VITE_ASSET__DjQCFUIC__"